import { useEffect } from 'react'

import request from 'api'
import { putData, useAppDispatch, useAppSelector } from 'store'

export enum PlaceCategory {
  HOME = 1,
  WORK = 2,
  CAR = 3,
  ETC = 4,
  SCHOOL = 5
}

export interface Place {
  placeKey: string
  name: string
  category: number
  address: string
  bluetooth: {
    name: string
  }
}

export function usePlaces(forceFetch = false) {
  const places = useAppSelector((state) => state.data.places as Place[])
  const dispatch = useAppDispatch()

  const fetchPlaces = async () => {
    const fetchedData = await request
      .get<Place[]>('/v1/users/places')
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('FailedToFetch')
        }
        return response.data
      })
      .catch(() => {
        return [] as Place[]
      })

    dispatch(putData({ places: fetchedData }))
    return fetchedData
  }

  const deletePlace = async (placeKey: string) => {
    const isDeleted = await request
      .delete(`/v1/users/places/${placeKey}`)
      .then(() => {
        return true
      })
      .catch(() => {
        return false
      })

    if (isDeleted) {
      if (places === undefined) {
        // do nothing
      } else {
        dispatch(putData({ places: places.filter((place) => place.placeKey !== placeKey) }))
      }
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (forceFetch || places === undefined) {
      fetchPlaces()
    }
  }, [])

  return { places: places === undefined ? [] : places, isInitializing: places === undefined, fetchPlaces, deletePlace }
}
